import { render, staticRenderFns } from "./AbandonmentIndex.vue?vue&type=template&id=3e4d3b9e&scoped=true&"
import script from "./AbandonmentIndex.vue?vue&type=script&lang=js&"
export * from "./AbandonmentIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d3b9e",
  null
  
)

export default component.exports